import { Dialog } from "@mui/material";

export default function SuccessDialog({ open }: any) {
  return (
    <Dialog open={open} fullWidth={true}>
      <div
        onClick={() => {
          window.location.reload();
        }}
        className="cursor-pointer transition-all hover:bg-blue-100 min-h-[200px] bg-blue-50 flex flex-col justify-center items-center"
      >
        <img src="check.svg" className="w-32 p-4" alt="" />
        <span>شما با موفقیت ثبت نام کردید!</span>
      </div>
    </Dialog>
  );
}
